var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.26,
    height: 36.32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.491 26.22a6.678 6.678 0 0 0 6.672 6.67 6.677 6.677 0 0 0 6.673-6.67 6.677 6.677 0 0 0-6.673-6.67 6.678 6.678 0 0 0-6.672 6.67m-3.424 0a10.109 10.109 0 0 1 10.1-10.1 10.109 10.109 0 0 1 10.1 10.1 10.109 10.109 0 0 1-10.1 10.1 10.109 10.109 0 0 1-10.1-10.1M3.424 26.22a6.677 6.677 0 0 0 6.672 6.67 6.677 6.677 0 0 0 6.673-6.67 6.677 6.677 0 0 0-6.673-6.67 6.677 6.677 0 0 0-6.672 6.67M0 26.22a10.109 10.109 0 0 1 10.1-10.1 10.109 10.109 0 0 1 10.1 10.1 10.109 10.109 0 0 1-10.1 10.1A10.109 10.109 0 0 1 0 26.22",
    fill: "#3cb36f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.927 28.12 3.2-1.21-6.826-18.12H17.126v3.43h14.809Z",
    fill: "#3cb36f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.193 28.12 5.992-15.9h14.809V8.79H14.817L7.989 26.91Z",
    fill: "#3cb36f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.462 11.68 38.454 0h-8.54v3.42h3.751l-2.443 7.15Z",
    fill: "#3cb36f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.95 6.74h8.08V3.316h-8.08Z",
    fill: "#3cb36f",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.d49cdfdc555b0093ce2480f0055c36a4.svg";
export { ForwardRef as ReactComponent };